var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3271 0.310204C10.5384 0.109038 10.8196 -0.00217519 11.1113 3.2243e-05C11.403 0.00223967 11.6825 0.117695 11.8907 0.322036C12.099 0.526377 12.2197 0.803621 12.2274 1.09527C12.2351 1.38691 12.1292 1.67015 11.9321 1.8852L5.94706 9.37021C5.84415 9.48105 5.71994 9.57001 5.58186 9.63175C5.44378 9.6935 5.29467 9.72677 5.14344 9.72957C4.99221 9.73237 4.84197 9.70465 4.7017 9.64805C4.56143 9.59146 4.43401 9.50717 4.32706 9.4002L0.358063 5.4312C0.247532 5.32821 0.158879 5.20401 0.0973912 5.06601C0.0359033 4.92801 0.00284026 4.77904 0.00017508 4.62799C-0.0024901 4.47693 0.0252972 4.32689 0.0818787 4.18681C0.13846 4.04673 0.222677 3.91948 0.329505 3.81265C0.436333 3.70582 0.563584 3.6216 0.703666 3.56502C0.843749 3.50844 0.993792 3.48065 1.14485 3.48332C1.2959 3.48598 1.44487 3.51905 1.58287 3.58053C1.72087 3.64202 1.84507 3.73067 1.94806 3.8412L5.08906 6.9807L10.2986 0.343205C10.3079 0.331656 10.318 0.320639 10.3286 0.310204H10.3271Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.041f36482cfdcfcdb05f837eeecfa268.svg";
export { ForwardRef as ReactComponent };